import {combineReducers} from 'redux';
import ActiveSelectionReducer from './reducers/ActiveSelectionReducer';
import ModalReducer from './reducers/ModalReducer';
import { items, itemsHasErrored, itemsIsLoading } from './reducers/ProductsReducer'

const rootReducer = combineReducers({
  activeSelection: ActiveSelectionReducer,
  modalVisibility: ModalReducer,
  items,
  itemsHasErrored,
  itemsIsLoading
});

export default rootReducer;


/** WEBPACK FOOTER **
 ** ./src/reducers.js
 **/


/** WEBPACK FOOTER **
 ** ./src/reducers.js
 **/